const MockBigQueryInsights = {
  id: "bigQuery",
  aggregation: [1e4, 3e4],
  change: {
    ratio: 3,
    amount: 2e4
  },
  entities: {
    dataset: [
      {
        id: "dataset-a",
        aggregation: [5e3, 1e4],
        change: {
          ratio: 1,
          amount: 5e3
        },
        entities: {}
      },
      {
        id: "dataset-b",
        aggregation: [5e3, 1e4],
        change: {
          ratio: 1,
          amount: 5e3
        },
        entities: {}
      },
      {
        id: "dataset-c",
        aggregation: [0, 1e4],
        change: {
          amount: 1e4
        },
        entities: {}
      }
    ]
  }
};
const MockCloudDataflowInsights = {
  id: "cloudDataflow",
  aggregation: [1e5, 158e3],
  change: {
    ratio: 0.58,
    amount: 58e3
  },
  entities: {
    pipeline: [
      {
        id: null,
        aggregation: [1e4, 12e3],
        change: {
          ratio: 0.2,
          amount: 2e3
        },
        entities: {
          SKU: [
            {
              id: "Mock SKU A",
              aggregation: [3e3, 4e3],
              change: {
                ratio: 0.333333,
                amount: 1e3
              },
              entities: {}
            },
            {
              id: "Mock SKU B",
              aggregation: [7e3, 8e3],
              change: {
                ratio: 0.14285714,
                amount: 1e3
              },
              entities: {}
            }
          ]
        }
      },
      {
        id: "pipeline-a",
        aggregation: [6e4, 7e4],
        change: {
          ratio: 0.16666666666666666,
          amount: 1e4
        },
        entities: {
          SKU: [
            {
              id: "Mock SKU A",
              aggregation: [2e4, 15e3],
              change: {
                ratio: -0.25,
                amount: -5e3
              },
              entities: {}
            },
            {
              id: "Mock SKU B",
              aggregation: [3e4, 35e3],
              change: {
                ratio: -0.16666666666666666,
                amount: -5e3
              },
              entities: {}
            },
            {
              id: "Mock SKU C",
              aggregation: [1e4, 2e4],
              change: {
                ratio: 1,
                amount: 1e4
              },
              entities: {}
            }
          ]
        }
      },
      {
        id: "pipeline-b",
        aggregation: [12e3, 8e3],
        change: {
          ratio: -0.33333,
          amount: -4e3
        },
        entities: {
          SKU: [
            {
              id: "Mock SKU A",
              aggregation: [4e3, 4e3],
              change: {
                ratio: 0,
                amount: 0
              },
              entities: {}
            },
            {
              id: "Mock SKU B",
              aggregation: [8e3, 4e3],
              change: {
                ratio: -0.5,
                amount: -4e3
              },
              entities: {}
            }
          ]
        }
      },
      {
        id: "pipeline-c",
        aggregation: [0, 1e4],
        change: {
          amount: 1e4
        },
        entities: {}
      }
    ]
  }
};
const MockCloudStorageInsights = {
  id: "cloudStorage",
  aggregation: [45e3, 45e3],
  change: {
    ratio: 0,
    amount: 0
  },
  entities: {
    bucket: [
      {
        id: "bucket-a",
        aggregation: [15e3, 2e4],
        change: {
          ratio: 0.333,
          amount: 5e3
        },
        entities: {
          SKU: [
            {
              id: "Mock SKU A",
              aggregation: [1e4, 11e3],
              change: {
                ratio: 0.1,
                amount: 1e3
              },
              entities: {}
            },
            {
              id: "Mock SKU B",
              aggregation: [2e3, 5e3],
              change: {
                ratio: 1.5,
                amount: 3e3
              },
              entities: {}
            },
            {
              id: "Mock SKU C",
              aggregation: [3e3, 4e3],
              change: {
                ratio: 0.3333,
                amount: 1e3
              },
              entities: {}
            }
          ]
        }
      },
      {
        id: "bucket-b",
        aggregation: [3e4, 25e3],
        change: {
          ratio: -0.16666,
          amount: -5e3
        },
        entities: {
          SKU: [
            {
              id: "Mock SKU A",
              aggregation: [12e3, 13e3],
              change: {
                ratio: 0.08333333333333333,
                amount: 1e3
              },
              entities: {}
            },
            {
              id: "Mock SKU B",
              aggregation: [16e3, 12e3],
              change: {
                ratio: -0.25,
                amount: -4e3
              },
              entities: {}
            },
            {
              id: "Mock SKU C",
              aggregation: [2e3, 0],
              change: {
                amount: -2e3
              },
              entities: {}
            }
          ]
        }
      },
      {
        id: "bucket-c",
        aggregation: [0, 0],
        change: {
          amount: 0
        },
        entities: {}
      }
    ]
  }
};
const MockComputeEngineInsights = {
  id: "computeEngine",
  aggregation: [8e4, 9e4],
  change: {
    ratio: 0.125,
    amount: 1e4
  },
  entities: {
    service: [
      {
        id: "service-a",
        aggregation: [2e4, 1e4],
        change: {
          ratio: -0.5,
          amount: -1e4
        },
        entities: {
          SKU: [
            {
              id: "Mock SKU A",
              aggregation: [4e3, 2e3],
              change: {
                ratio: -0.5,
                amount: -2e3
              },
              entities: {}
            },
            {
              id: "Mock SKU B",
              aggregation: [7e3, 6e3],
              change: {
                ratio: -0.14285714285714285,
                amount: -1e3
              },
              entities: {}
            },
            {
              id: "Mock SKU C",
              aggregation: [9e3, 2e3],
              change: {
                ratio: -0.7777777777777778,
                amount: -7e3
              },
              entities: {}
            }
          ],
          deployment: [
            {
              id: "Compute Engine",
              aggregation: [7e3, 6e3],
              change: {
                ratio: -0.5,
                amount: -2e3
              },
              entities: {}
            },
            {
              id: "Kubernetes",
              aggregation: [4e3, 2e3],
              change: {
                ratio: -0.14285714285714285,
                amount: -1e3
              },
              entities: {}
            }
          ]
        }
      },
      {
        id: "service-b",
        aggregation: [1e4, 2e4],
        change: {
          ratio: 1,
          amount: 1e4
        },
        entities: {
          SKU: [
            {
              id: "Mock SKU A",
              aggregation: [1e3, 2e3],
              change: {
                ratio: 1,
                amount: 1e3
              },
              entities: {}
            },
            {
              id: "Mock SKU B",
              aggregation: [4e3, 8e3],
              change: {
                ratio: 1,
                amount: 4e3
              },
              entities: {}
            },
            {
              id: "Mock SKU C",
              aggregation: [5e3, 1e4],
              change: {
                ratio: 1,
                amount: 5e3
              },
              entities: {}
            }
          ],
          deployment: [
            {
              id: "Compute Engine",
              aggregation: [7e3, 6e3],
              change: {
                ratio: -0.5,
                amount: -2e3
              },
              entities: {}
            },
            {
              id: "Kubernetes",
              aggregation: [4e3, 2e3],
              change: {
                ratio: -0.14285714285714285,
                amount: -1e3
              },
              entities: {}
            }
          ]
        }
      },
      {
        id: "service-c",
        aggregation: [0, 1e4],
        change: {
          amount: 1e4
        },
        entities: {}
      }
    ]
  }
};
const MockEventsInsights = {
  id: "events",
  aggregation: [2e4, 1e4],
  change: {
    ratio: -0.5,
    amount: -1e4
  },
  entities: {
    event: [
      {
        id: "event-a",
        aggregation: [15e3, 7e3],
        change: {
          ratio: -0.53333333333,
          amount: -8e3
        },
        entities: {
          product: [
            {
              id: "Mock Product A",
              aggregation: [5e3, 2e3],
              change: {
                ratio: -0.6,
                amount: -3e3
              },
              entities: {}
            },
            {
              id: "Mock Product B",
              aggregation: [7e3, 2500],
              change: {
                ratio: -0.64285714285,
                amount: -4500
              },
              entities: {}
            },
            {
              id: "Mock Product C",
              aggregation: [3e3, 2500],
              change: {
                ratio: -0.16666666666,
                amount: -500
              },
              entities: {}
            }
          ]
        }
      },
      {
        id: "event-b",
        aggregation: [5e3, 3e3],
        change: {
          ratio: -0.4,
          amount: -2e3
        },
        entities: {
          product: [
            {
              id: "Mock Product A",
              aggregation: [2e3, 1e3],
              change: {
                ratio: -0.5,
                amount: -1e3
              },
              entities: {}
            },
            {
              id: "Mock Product B",
              aggregation: [1e3, 1500],
              change: {
                ratio: 0.5,
                amount: 500
              },
              entities: {}
            },
            {
              id: "Mock Product C",
              aggregation: [2e3, 500],
              change: {
                ratio: -0.75,
                amount: -1500
              },
              entities: {}
            }
          ]
        }
      }
    ]
  }
};

export { MockBigQueryInsights, MockCloudDataflowInsights, MockCloudStorageInsights, MockComputeEngineInsights, MockEventsInsights };
//# sourceMappingURL=mockData.esm.js.map
